import { isThemeApplied, THEMES } from '@/utils/whiteLabeling/whiteLabelingConfig';

if (isThemeApplied(THEMES.apprize)) {
  import('./gotham-rounded.scss');
} else if (isThemeApplied(THEMES.gusto)) {
  import('./g-centra.scss');
} else if (isThemeApplied(THEMES.helix)) {
  import('./monserat.scss');
} else if (isThemeApplied(THEMES.rippling)) {
  import('./red-hat.scss');
} else if (isThemeApplied(THEMES.rmr)) {
  import('./open-sans.scss');
} else if (isThemeApplied(THEMES.proficient)) {
  import('./museo-sans.scss');
} else if (isThemeApplied(THEMES.nationwide)) {
  import('./Tiempos.scss');
} else {
  import('./inter.scss');
}
